import { API } from '~/data/api'

export const useCommentsService = () => {
  async function createComment(endPoint: string, data: { text: string; timestamp: Date }) {
    const response = await API.createComment(endPoint, {
      text: data.text.trim(),
      timestamp: data.timestamp
    })
    return response?.data.id
  }

  async function updateComment(endPoint: string, data: { text: string; timestamp: Date }) {
    const response = await API.putComment(endPoint, {
      text: data.text.trimEnd(),
      timestamp: data.timestamp
    })
    return response?.data.id
  }

  async function deleteComment(endPoint: string) {
    await API.deleteComment(endPoint)
  }

  async function getComments(endPoint: string) {
    const response = await API.getComments(endPoint)
    return response?.data
  }

  async function getCommentsPage(url: string) {
    const response = await API.getCommentsPage(url)
    return response?.data
  }

  async function reportComment(endPoint: string, note: string, reason: string) {
    const response = await API.reportComment(endPoint, note, reason)
    return response?.data
  }

  return {
    createComment,
    updateComment,
    deleteComment,
    getComments,
    getCommentsPage,
    reportComment
  }
}
